import { apiClient } from "../../../base/ApiClient";

export const fetchConversations = async () => {
  const response = await apiClient.get('/communications/sms/conversations/');
  return response.data; 
};

export const fetchChatHistory = async (phoneNumber) => {
  if (!phoneNumber) return [];
  const response = await apiClient.get(`/communications/sms/history/${phoneNumber}/`);
  return response.data; 
};

export const fetchGroupChatHistory = async (limit = 20) => {
  const response = await apiClient.get(`/communications/group-messages/?limit=${limit}`);
  return response.data;
};

export const sendChatMessage = async (smsPayload) => {
  const response = await apiClient.post('/communications/sms/send', smsPayload);
  return response.data;
};

export const sendGroupChatMessage = async (groupPayload) => {
  const response = await apiClient.post('/communications/sms/send-group', groupPayload);
  return response.data;
};